/**
 * Rider-Waite card art (1909, public domain).
 *
 * Bundled via Parcel `url:` imports (the same pattern as arrow.webp), so the
 * URLs work identically in the parcel dev server, the nginx production image and
 * the Capacitor webview. Keyed by exact file name.
 */
import img_00_TheFool from 'url:../../../assets/images/rider-waite/00-TheFool.jpg';
import img_01_TheMagician from 'url:../../../assets/images/rider-waite/01-TheMagician.jpg';
import img_02_TheHighPriestess from 'url:../../../assets/images/rider-waite/02-TheHighPriestess.jpg';
import img_03_TheEmpress from 'url:../../../assets/images/rider-waite/03-TheEmpress.jpg';
import img_04_TheEmperor from 'url:../../../assets/images/rider-waite/04-TheEmperor.jpg';
import img_05_TheHierophant from 'url:../../../assets/images/rider-waite/05-TheHierophant.jpg';
import img_06_TheLovers from 'url:../../../assets/images/rider-waite/06-TheLovers.jpg';
import img_07_TheChariot from 'url:../../../assets/images/rider-waite/07-TheChariot.jpg';
import img_08_Strength from 'url:../../../assets/images/rider-waite/08-Strength.jpg';
import img_09_TheHermit from 'url:../../../assets/images/rider-waite/09-TheHermit.jpg';
import img_10_WheelOfFortune from 'url:../../../assets/images/rider-waite/10-WheelOfFortune.jpg';
import img_11_Justice from 'url:../../../assets/images/rider-waite/11-Justice.jpg';
import img_12_TheHangedMan from 'url:../../../assets/images/rider-waite/12-TheHangedMan.jpg';
import img_13_Death from 'url:../../../assets/images/rider-waite/13-Death.jpg';
import img_14_Temperance from 'url:../../../assets/images/rider-waite/14-Temperance.jpg';
import img_15_TheDevil from 'url:../../../assets/images/rider-waite/15-TheDevil.jpg';
import img_16_TheTower from 'url:../../../assets/images/rider-waite/16-TheTower.jpg';
import img_17_TheStar from 'url:../../../assets/images/rider-waite/17-TheStar.jpg';
import img_18_TheMoon from 'url:../../../assets/images/rider-waite/18-TheMoon.jpg';
import img_19_TheSun from 'url:../../../assets/images/rider-waite/19-TheSun.jpg';
import img_20_Judgement from 'url:../../../assets/images/rider-waite/20-Judgement.jpg';
import img_21_TheWorld from 'url:../../../assets/images/rider-waite/21-TheWorld.jpg';
import img_CardBacks from 'url:../../../assets/images/rider-waite/CardBacks.jpg';
import img_Cups01 from 'url:../../../assets/images/rider-waite/Cups01.jpg';
import img_Cups02 from 'url:../../../assets/images/rider-waite/Cups02.jpg';
import img_Cups03 from 'url:../../../assets/images/rider-waite/Cups03.jpg';
import img_Cups04 from 'url:../../../assets/images/rider-waite/Cups04.jpg';
import img_Cups05 from 'url:../../../assets/images/rider-waite/Cups05.jpg';
import img_Cups06 from 'url:../../../assets/images/rider-waite/Cups06.jpg';
import img_Cups07 from 'url:../../../assets/images/rider-waite/Cups07.jpg';
import img_Cups08 from 'url:../../../assets/images/rider-waite/Cups08.jpg';
import img_Cups09 from 'url:../../../assets/images/rider-waite/Cups09.jpg';
import img_Cups10 from 'url:../../../assets/images/rider-waite/Cups10.jpg';
import img_Cups11 from 'url:../../../assets/images/rider-waite/Cups11.jpg';
import img_Cups12 from 'url:../../../assets/images/rider-waite/Cups12.jpg';
import img_Cups13 from 'url:../../../assets/images/rider-waite/Cups13.jpg';
import img_Cups14 from 'url:../../../assets/images/rider-waite/Cups14.jpg';
import img_Pentacles01 from 'url:../../../assets/images/rider-waite/Pentacles01.jpg';
import img_Pentacles02 from 'url:../../../assets/images/rider-waite/Pentacles02.jpg';
import img_Pentacles03 from 'url:../../../assets/images/rider-waite/Pentacles03.jpg';
import img_Pentacles04 from 'url:../../../assets/images/rider-waite/Pentacles04.jpg';
import img_Pentacles05 from 'url:../../../assets/images/rider-waite/Pentacles05.jpg';
import img_Pentacles06 from 'url:../../../assets/images/rider-waite/Pentacles06.jpg';
import img_Pentacles07 from 'url:../../../assets/images/rider-waite/Pentacles07.jpg';
import img_Pentacles08 from 'url:../../../assets/images/rider-waite/Pentacles08.jpg';
import img_Pentacles09 from 'url:../../../assets/images/rider-waite/Pentacles09.jpg';
import img_Pentacles10 from 'url:../../../assets/images/rider-waite/Pentacles10.jpg';
import img_Pentacles11 from 'url:../../../assets/images/rider-waite/Pentacles11.jpg';
import img_Pentacles12 from 'url:../../../assets/images/rider-waite/Pentacles12.jpg';
import img_Pentacles13 from 'url:../../../assets/images/rider-waite/Pentacles13.jpg';
import img_Pentacles14 from 'url:../../../assets/images/rider-waite/Pentacles14.jpg';
import img_Swords01 from 'url:../../../assets/images/rider-waite/Swords01.jpg';
import img_Swords02 from 'url:../../../assets/images/rider-waite/Swords02.jpg';
import img_Swords03 from 'url:../../../assets/images/rider-waite/Swords03.jpg';
import img_Swords04 from 'url:../../../assets/images/rider-waite/Swords04.jpg';
import img_Swords05 from 'url:../../../assets/images/rider-waite/Swords05.jpg';
import img_Swords06 from 'url:../../../assets/images/rider-waite/Swords06.jpg';
import img_Swords07 from 'url:../../../assets/images/rider-waite/Swords07.jpg';
import img_Swords08 from 'url:../../../assets/images/rider-waite/Swords08.jpg';
import img_Swords09 from 'url:../../../assets/images/rider-waite/Swords09.jpg';
import img_Swords10 from 'url:../../../assets/images/rider-waite/Swords10.jpg';
import img_Swords11 from 'url:../../../assets/images/rider-waite/Swords11.jpg';
import img_Swords12 from 'url:../../../assets/images/rider-waite/Swords12.jpg';
import img_Swords13 from 'url:../../../assets/images/rider-waite/Swords13.jpg';
import img_Swords14 from 'url:../../../assets/images/rider-waite/Swords14.jpg';
import img_Wands01 from 'url:../../../assets/images/rider-waite/Wands01.jpg';
import img_Wands02 from 'url:../../../assets/images/rider-waite/Wands02.jpg';
import img_Wands03 from 'url:../../../assets/images/rider-waite/Wands03.jpg';
import img_Wands04 from 'url:../../../assets/images/rider-waite/Wands04.jpg';
import img_Wands05 from 'url:../../../assets/images/rider-waite/Wands05.jpg';
import img_Wands06 from 'url:../../../assets/images/rider-waite/Wands06.jpg';
import img_Wands07 from 'url:../../../assets/images/rider-waite/Wands07.jpg';
import img_Wands08 from 'url:../../../assets/images/rider-waite/Wands08.jpg';
import img_Wands09 from 'url:../../../assets/images/rider-waite/Wands09.jpg';
import img_Wands10 from 'url:../../../assets/images/rider-waite/Wands10.jpg';
import img_Wands11 from 'url:../../../assets/images/rider-waite/Wands11.jpg';
import img_Wands12 from 'url:../../../assets/images/rider-waite/Wands12.jpg';
import img_Wands13 from 'url:../../../assets/images/rider-waite/Wands13.jpg';
import img_Wands14 from 'url:../../../assets/images/rider-waite/Wands14.jpg';
import img_back from 'url:../../../assets/images/rider-waite/back.jpg';

export const RIDER_WAITE_IMAGE_URLS: Readonly<Record<string, string>> = {
    '00-TheFool.jpg': img_00_TheFool,
    '01-TheMagician.jpg': img_01_TheMagician,
    '02-TheHighPriestess.jpg': img_02_TheHighPriestess,
    '03-TheEmpress.jpg': img_03_TheEmpress,
    '04-TheEmperor.jpg': img_04_TheEmperor,
    '05-TheHierophant.jpg': img_05_TheHierophant,
    '06-TheLovers.jpg': img_06_TheLovers,
    '07-TheChariot.jpg': img_07_TheChariot,
    '08-Strength.jpg': img_08_Strength,
    '09-TheHermit.jpg': img_09_TheHermit,
    '10-WheelOfFortune.jpg': img_10_WheelOfFortune,
    '11-Justice.jpg': img_11_Justice,
    '12-TheHangedMan.jpg': img_12_TheHangedMan,
    '13-Death.jpg': img_13_Death,
    '14-Temperance.jpg': img_14_Temperance,
    '15-TheDevil.jpg': img_15_TheDevil,
    '16-TheTower.jpg': img_16_TheTower,
    '17-TheStar.jpg': img_17_TheStar,
    '18-TheMoon.jpg': img_18_TheMoon,
    '19-TheSun.jpg': img_19_TheSun,
    '20-Judgement.jpg': img_20_Judgement,
    '21-TheWorld.jpg': img_21_TheWorld,
    'CardBacks.jpg': img_CardBacks,
    'Cups01.jpg': img_Cups01,
    'Cups02.jpg': img_Cups02,
    'Cups03.jpg': img_Cups03,
    'Cups04.jpg': img_Cups04,
    'Cups05.jpg': img_Cups05,
    'Cups06.jpg': img_Cups06,
    'Cups07.jpg': img_Cups07,
    'Cups08.jpg': img_Cups08,
    'Cups09.jpg': img_Cups09,
    'Cups10.jpg': img_Cups10,
    'Cups11.jpg': img_Cups11,
    'Cups12.jpg': img_Cups12,
    'Cups13.jpg': img_Cups13,
    'Cups14.jpg': img_Cups14,
    'Pentacles01.jpg': img_Pentacles01,
    'Pentacles02.jpg': img_Pentacles02,
    'Pentacles03.jpg': img_Pentacles03,
    'Pentacles04.jpg': img_Pentacles04,
    'Pentacles05.jpg': img_Pentacles05,
    'Pentacles06.jpg': img_Pentacles06,
    'Pentacles07.jpg': img_Pentacles07,
    'Pentacles08.jpg': img_Pentacles08,
    'Pentacles09.jpg': img_Pentacles09,
    'Pentacles10.jpg': img_Pentacles10,
    'Pentacles11.jpg': img_Pentacles11,
    'Pentacles12.jpg': img_Pentacles12,
    'Pentacles13.jpg': img_Pentacles13,
    'Pentacles14.jpg': img_Pentacles14,
    'Swords01.jpg': img_Swords01,
    'Swords02.jpg': img_Swords02,
    'Swords03.jpg': img_Swords03,
    'Swords04.jpg': img_Swords04,
    'Swords05.jpg': img_Swords05,
    'Swords06.jpg': img_Swords06,
    'Swords07.jpg': img_Swords07,
    'Swords08.jpg': img_Swords08,
    'Swords09.jpg': img_Swords09,
    'Swords10.jpg': img_Swords10,
    'Swords11.jpg': img_Swords11,
    'Swords12.jpg': img_Swords12,
    'Swords13.jpg': img_Swords13,
    'Swords14.jpg': img_Swords14,
    'Wands01.jpg': img_Wands01,
    'Wands02.jpg': img_Wands02,
    'Wands03.jpg': img_Wands03,
    'Wands04.jpg': img_Wands04,
    'Wands05.jpg': img_Wands05,
    'Wands06.jpg': img_Wands06,
    'Wands07.jpg': img_Wands07,
    'Wands08.jpg': img_Wands08,
    'Wands09.jpg': img_Wands09,
    'Wands10.jpg': img_Wands10,
    'Wands11.jpg': img_Wands11,
    'Wands12.jpg': img_Wands12,
    'Wands13.jpg': img_Wands13,
    'Wands14.jpg': img_Wands14,
    'back.jpg': img_back,
} as const;
